module.exports = __webpack_public_path__ + "img/1.bfae66fd.png";